/*
 * SC Product Options (Bold) の補助ローダー。
 * options.js はページ読み込み時にしか .bold_options を走査しないため、
 * クイック追加ドロワーのように後から挿入されるフォームでは描画されない。
 * 追加された .bold_options[data-product-id] を監視し、商品を登録してから
 * BOLD.options.app.loadOptionProduct(要素) を呼んで描画させる。
 */
(function () {
  var SELECTOR = '.bold_options[data-product-id]';

  function appReady() {
    return !!(window.BOLD && BOLD.options && BOLD.options.app &&
      typeof BOLD.options.app.loadOptionProduct === 'function' &&
      BOLD.common && BOLD.common.Shopify && BOLD.common.Shopify.saveProduct);
  }

  // bold-common.liquid が商品ページ/コレクションページで行う登録と同じことをする
  function registerProduct(el) {
    var S = BOLD.common.Shopify;
    var pid = Number(el.getAttribute('data-product-id'));
    var handle = el.getAttribute('data-bold-handle');
    if (!pid || !handle) return;
    S.saveProduct(handle, pid);
    var variants = [];
    try { variants = JSON.parse(el.getAttribute('data-bold-variants') || '[]'); } catch (e) {}
    variants.forEach(function (v) {
      S.saveVariant(Number(v.id), {
        product_id: pid, product_handle: handle, price: v.price, group_id: '', csp_metafield: null
      });
    });
  }

  function load(el) {
    if (el.children.length || el.__boldLoading) return;
    el.__boldLoading = true;
    registerProduct(el);
    try { BOLD.options.app.loadOptionProduct(el); } catch (e) {}
    setTimeout(function () { el.__boldLoading = false; }, 3000);
  }

  function scan(root) {
    if (!appReady()) return false;
    if (root.nodeType !== 1) return true;
    if (root.matches && root.matches(SELECTOR)) load(root);
    root.querySelectorAll(SELECTOR).forEach(load);
    return true;
  }

  var pending = [];
  function flush() {
    if (!appReady()) { setTimeout(flush, 300); return; }
    pending.splice(0).forEach(scan);
  }

  // 初期表示分は options.js 自身が処理するので、以後に追加されたノードだけ扱う
  function start() {
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        r.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (!scan(n)) { pending.push(n); flush(); }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
